var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9259 20.326L7.50355 25.9333L3.69995 21.4397V33.3H15.5159L11.0204 29.4502L16.6259 24.026L12.9259 20.326ZM21.484 3.70001L25.9795 7.54986L20.374 12.9741L24.074 16.6741L29.4964 11.0667L33.2999 15.5604V3.70001H21.484Z",
    fill: "#324395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsIcon);
export default __webpack_public_path__ + "static/media/ArrowsIcon.9a378db9baf02899ad08307e181bb9cf.svg";
export { ForwardRef as ReactComponent };